import './addtocart.css'
import {ReactComponent as LoadingLogo} from '../components/loading/loading.svg';

const AddToCartAnimation = ({show}) => {
  if (show) {
    return (
      <div className="ani-backdrop"><div className="add-to-cart-ani"><LoadingLogo></LoadingLogo></div></div>
    )
  } else {
    return <div></div>
  }
}

export default AddToCartAnimation;